/* global $ */

const Prompt = {
  /**
   * Instantiate prompt
   * @param {Object} obj
   * @return {Promise}
   */
  create(obj) {
    return new Promise((resolve, reject) => {
      this.$promptElement = this.createPrompt(obj);

      // Add it to the DOM
      $('body').append(this.$promptElement);

      this.$promptElement.on('hide.bs.modal', () => {
        reject();
      });

      this.$promptElement.on('click', '.js-button-success', () => {
        resolve();
        this.$promptElement.modal('hide');
      });

      this.$promptElement.on('hidden.bs.modal', () => {
        this.$promptElement.remove();
      });

      this.$promptElement.modal('show');
    });
  },

  /**
   * Create prompt element
   * @param {String} text Text for the prompt element
   * @param {String} btnSuccessText Success button text
   * @param {String} btnCancelText Cancel button text
   * @return {Object}
   */
  createPrompt(obj) {
    let promptTemplate = document.getElementById('prompt-template').innerHTML;

    const id = Math.round((Math.random() * 10000) + 10000);

    promptTemplate = promptTemplate.replace(/{{ id }}/g, `id_${id}`);
    promptTemplate = promptTemplate.replace('{{ title }}', obj.title);
    promptTemplate = promptTemplate.replace('{{ btn_success }}', obj.btnSuccessText);
    promptTemplate = promptTemplate.replace('{{ btn_cancel }}', obj.btnCancelText);

    const $prompt = $(promptTemplate);

    if (typeof obj.btnSuccessText === 'undefined' || !obj.btnSuccessText) {
      $prompt.find('.js-button-success').remove();
    }

    if (typeof obj.btnCancelText === 'undefined' || !obj.btnCancelText) {
      $prompt.find('.js-button-cancel').remove();
    }

    return $prompt;
  },
};

const Prompts = {

  /**
   * Create
   * @return {Promise}
   */
  create(...args) {
    const prompt = Object.assign({}, Prompt);
    return prompt.create(...args);
  },
};

export default Prompts;
